export default {
  'Something went wrong. Please try again or contact admin for supports.':
    'Có lỗi xảy ra. Vui lòng liên hệ quản trị viên',
  'This user has already been in another institution.':
    'Người dùng này tồn tại trong một cơ sở khác.',
  'Institution code has already been used': 'Mã cơ sở đã được sử dụng',
  'Please upload a file less than 1.5MB': ' Vui lòng tải lên tệp dưới 1,5 MB',
  'Role code has already been used': 'Mã nhóm quyền đã được sử dụng',
  'Not found role ID': 'Không tìm thấy mã nhóm quyền',
  'Cannot delete default roles': 'Không thể xóa nhóm quyền mặc định',
  'Role name has already been used': 'Tên nhóm quyền đã được sử dụng',
  'User name has already been used': 'Tên người dùng đã được sử dụng',
  'Group Account has already been used': 'Nhóm tài khoản đã được sử dụng',
  'Not found study ID': 'Không tìm thấy mã ca chụp',
  'Fail to sync match status to studylist':
    'Không đồng bộ được trạng thái ghép nối với danh sách ca chụp',
  'Procedure group name has already been used':
    'Tên nhóm dịch vụ đã được sử dụng',
  'Procedure code has already been used': 'Mã dịch vụ đã được sử dụng',
  'Body part name has already been used': 'Tên bộ phận chụp đã được sử dụng',
  'Department code has already been used': 'Mã khoa phòng đã được sử dụng',
  'Department name has already been used': 'Tên khoa phòng đã được sử dụng',
  'Not found recorded annotation': 'Không tìm thấy chú thích',
  'Fail to update this recorded annotation': 'Không thể cập nhật chú thích',
  'Fail to create this recorded annotation': 'Không thể tạo mới chú thích',
  'Fail to get the recorded annotations': 'Không thể lấy thông tin chú thích',
  'Wrong owner of this recorded annotation': 'Không thể xử lý chú thích của người khác',
  'Fail to delete recorded annotation': 'Không thể xóa chú thích',
  'Not found valid study to perform': 'Không tìm thấy ca chụp',
  'Template Report Code already been used': 'Mã mẫu báo cáo đã được sử dụng',
  'Patient ID invalid, please choose the same Patient ID':
    'Mã người bệnh không hợp lệ, vui lòng chọn cùng một mã người bệnh',
  'Order already been used': 'Chỉ định đã được sử dụng',
  'Not found order ID': 'Không tìm thấy mã chỉ định',
  'Order status is Matched. Please unmatch first.':
    'Chỉ định đã được ghép nối. Vui lòng hủy ghép nối trước.',
  'Fail to match order with study.': 'Lỗi ghép nối chỉ định với ca chụp.',
  'Fail to unmatch order with study.': 'Lỗi hủy ghép nối chỉ định với ca chụp',
  'Fail to sync order status.': 'Lỗi đồng bộ trạng thái chỉ định.',
  'Visit ID already been used. Please fill a different value or leave it blank':
    'Mã hồ sơ đã được sử dụng. Vui lòng điền một giá trị khác hoặc để trống',
  'Order ID already been used. Please fill a different value or leave it blank':
    'Mã chỉ định đã được sử dụng. Vui lòng điền một giá trị khác hoặc để trống',
  'Cannot auto generate ID. Please try again or contact admin for supports':
    'Không thể tự động tạo mã. Vui lòng thử lại hoặc liên hệ với quản trị viên để được hỗ trợ',
  'Cannot assign procedures to order. Please fill valid procedures.':
    'Không thể gán các dịch vụ cho chỉ định. Vui lòng điền các dịch vụ hợp lệ.',
  'Cannot assign device to order. Please fill a valid device.':
    'Không thể gán thiết bị cho chỉ định. Vui lòng điền vào một thiết bị hợp lệ.',
  'Invalid patient ID. Please fill a valid patient ID or leave it blank.':
    'Mã người bệnh không hợp lệ. Vui lòng điền mã người bệnh hợp lệ hoặc để trống.',
  'Fail to receive': 'Lỗi tiếp nhận',
  'Institution mismatch. please choose the same Institution':
    'Cơ sở không phù hợp. vui lòng chọn cùng một cơ sở',
  'Invalid order status. Please choose status is New/Cancel.':
    'Trạng thái chỉ định không hợp lệ. Vui lòng chọn trạng thái là Mới/Hủy.',
  'Invalid order status.': 'Trạng thái chỉ định không hợp lệ.',
  'Please choose procedure': 'Vui lòng chọn dịch vụ',
  'Cannot delete order with status is ARRIVED':
    'Không thể xóa chỉ định có trạng thái ĐÃ ĐẾN',
  'Layout Report Name already been used': 'Tên mẫu in đã được sử dụng',
  'Not found layout ID': 'Không tìm thấy mã mẫu in',
  'Approve all reports before create new':
    'Phê duyệt tất cả các báo cáo trước khi tạo mới',
  'Not found report': 'Không tìm thấy báo cáo',
  "Invalid report's actions flow": 'Luồng báo cáo không hợp lệ',
  'Another doctor is reading this report':
    'Báo cáo đang được đọc bởi bác sĩ khác',
  'Fail to cancel report': 'Lỗi hủy báo cáo',
  'Device name has already been used': 'Tên thiết bị đã được sử dụng',
  'Fail to share study': 'Lỗi chia sẻ ca chụp',
  'Fail to update share study': 'Lỗi cập nhật chia sẻ ca chụp',
  'Cannot delete expired share study':
    'Không thể xóa chia sẻ ca chụp đã hết hạn',
  "Limited study share on a month's":
    'Chia sẻ ca chụp giới hạn trong một tháng',
  'Invalid institution to share study': 'Cơ sở không hợp lệ để chia sẻ ca chụp',
  'Filter Name has already been used': 'Tên bộ lọc đã được sử dụng',
  'Not found filter': 'Không tìm thấy bộ lọc',
  'Fail to create rule CAD': 'Không thể tạo quy tắc cho CAD',
  'Fail to update rule CAD': 'Không thể cập nhật quy tắc cho CAD',
  'Fail to delete rule CAD': 'Không thể xóa quy tắc cho CAD',
  'Can not find rule CAD': 'Không thể tìm thấy quy tắc  cho CAD',
  'Can\'t update the request has been marked as either "reading" or "completed"':
    'Không thể cập nhật yêu cầu đã được đánh dấu là "đang đọc" hoặc "đã hoàn thành"',
  'Can\'t delete the request has been marked as either "reading" or "completed"':
    'Không thể xóa được yêu cầu đã được đánh dấu là "đang đọc" hoặc "đã hoàn thành"',
  'Please choose group account': 'Vui lòng chọn nhóm tài khoản',
  'Please choose account': 'Vui lòng chọn tài khoản',
  'Can not delete all data. Please contact admin for supports.':
    'Không thể xóa tất cả dữ liệu. Vui lòng liên hệ với quản trị viên để được hỗ trợ.',
  'Can not create or reset password. Please contact admin for supports.':
    'Không thể tạo hoặc đặt lại mật khẩu. Vui lòng liên hệ với quản trị viên để được hỗ trợ.',
  'Can not create or reset password. Please update phone number':
    'Không thể tạo hoặc đặt lại mật khẩu. Vui lòng cập nhật số điện thoại',
  'Institution ID invalid. Please contact admin for supports':
    'Mã cơ sở không hợp lệ. Vui lòng liên hệ quản trị viên để được hỗ trợ',
  'Fail to create print job': 'Không thể tạo lệnh in',
  'Please fill value in this field': 'Vui lòng điền giá trị vào trường này',
  'Enter in the format: name@example.com':
    'Nhập theo định dạng: name@example.com',
  'At least 10 numbers and allow character +':
    'Ít nhất 10 số và cho phép ký tự +',
  'At least 8 characters long': 'Yêu cầu ít nhất 8 kí tự',
  'The password confirmation does not match': 'Xác nhận mật khẩu không khớp',
  'The password is incorrect': 'Mật khẩu không đúng',
  'Are you sure you want to delete institution?':
    'Bạn có chắc chắn muốn xóa cơ sở?',
  'Are you sure you want to delete role?':
    'Bạn có chắc chắn muốn xóa nhóm quyền?',
  'Are you sure you want to delete user?':
    'Bạn có chắc chắn muốn xóa người dùng?',
  'Are you sure you want to delete group account?':
    'Bạn có chắc chắn muốn xóa nhóm tài khoản?',
  'Are you sure want to unmacth order?':
    'Bạn có chắc chắn muốn hủy ghép nối chỉ định?',
  'Are you sure you want to delete procedure group?':
    'Bạn có chắc chắn muốn xóa nhóm dịch vụ?',
  'Are you sure you want to delete procedure?':
    'Bạn có chắc chắn muốn xóa dịch vụ?',
  'Are you sure you want to delete body part?':
    'Bạn có chắc chắn muốn xóa bộ phận chụp?',
  'Are you sure you want to delete department?':
    'Bạn có chắc chắn muốn xóa khoa phòng?',
  'Are you sure want to delete template report?':
    'Bạn có chắc chắn muốn xóa mãu báo cáo?',
  'Are you sure want to delete order?': 'Bạn có chắc chắn muốn xóa chỉ định?',
  'Are you sure want to delete layout report?':
    'Bạn có chắc chắn muốn xóa mẫu in?',
  'This template will overwrite your current work. Do you want to continue?':
    'Mẫu báo cáo này sẽ ghi đè nội dung hiện tại. Bạn có muốn tiếp tục?',
  'Are you sure want to delete device?': 'Bạn có chắc chắn muốn xóa thiết bị?',
  'Are you sure want to delete share study?':
    'Bạn có chắc chắn muốn xóa chia sẻ ca chụp?',
  'Are you sure want to delete this filter?':
    'Bạn có chắc chắn muốn xóa bộ lọc?',
  'Are you sure want to delete this rule CAD?':
    'Bạn có chắc chắn muốn xóa quy tắc CAD?',
  'Are you sure want to delete this request?':
    'Bạn có chắc chắn muốn xóa yêu cầu?',
  'Are you sure want to delete patient?':
    'Bạn có chắc chắn muốn xóa người bệnh?',
  'Are you sure want to reset password?':
    'Bạn có chắc chắn muốn đặt lại mật khẩu?',
  'The institution has been created': 'Cơ sở đã được tạo',
  'The institution has been updated': 'Cơ sở đã được cập nhật',
  'The institution has been deleted': 'Cơ sở đã bị xóa',
  'The role has been created': 'Nhóm quyền đã được tạo',
  'The role has been updated': 'Nhóm quyền đã được cập nhật',
  'The role has been deleted': 'Nhóm quyền đã bị xóa',
  'The account has been created': 'Tài khoản đã được tạo',
  'The account has been updated': 'Tài khoản đã được cập nhật',
  'The account has been deleted': 'Tài khoản đã bị xóa',
  'Group account has been created': 'Nhóm tài khoản đã được tạo',
  'Group account has been updated': 'Nhóm tài khoản đã được cập nhật',
  'Group account has been deleted': 'Nhóm tài khoản đã bị xóa',
  'All orders have been matched': 'Tất cả chỉ định đã được ghép nối',
  'All orders have been unmatched': 'Tất cả các chỉ định đã được hủy ghép nối',
  'The procedure group has been created': 'Nhóm dịch vụ đã được tạo',
  'The procedure group has been updated': 'Nhóm dịch vụ đã được cập nhật',
  'The procedure group has been deleted': 'Nhóm dịch vụ đã bị xóa',
  'The procedure has been created': 'Dịch vụ đã được tạo',
  'The procedure has been updated': 'Dịch vụ đã được cập nhật',
  'The procedure has been deleted': 'Dịch vụ đã bị xóa',
  'The body part has been created': 'Bộ phận chụp đã được tạo',
  'The body part has been updated': 'Bộ phận chụp đã được cập nhật',
  'The body part has been deleted': 'Bộ phận chụp đã bị xóa',
  'The department has been created': 'Khoa phòng đã được tạo',
  'The department has been updated': 'Khoa phòng đã được cập nhật',
  'The department has been deleted': 'Khoa phòng đã bị xóa',
  'The template report has been created': 'Mẫu báo cáo đã được tạo',
  'The template report has been updated': 'Mẫu Báo cáo đã được cập nhật',
  'The template report has been deleted': 'Mẫu Báo cáo đã bị xóa',
  'The order has been created': 'Chỉ định đã được tạo',
  'The order has been updated': 'Chỉ định đã được cập nhật',
  'The order has been deleted': 'Chỉ định đã bị xóa',
  'You can use this Patient ID': 'Bạn có thể sử dụng mã người bệnh này',
  'The order has been received': 'Chỉ định đã được tiếp nhận',
  'The layout report has been created': 'Mẫu in đã được tạo',
  'The layout report has been updated': 'Mẫu in đã được cập nhật',
  'The layout report has been deleted': 'Mẫu in đã bị xóa',
  'The report has been created': 'Báo cáo đã được tạo',
  'The report has been updated': 'Báo cáo đã được cập nhật',
  'The report has been deleted': 'Báo cáo đã bị xóa',
  'The device has been created': 'Thiết bị đã được tạo',
  'The device has been updated': 'Thiết bị đã được cập nhật',
  'The device has been deleted': 'Thiết bị đã bị xóa',
  'This study has been shared': 'Ca chụp này đã được chia sẻ',
  'This study share has been updated': 'Chia sẻ ca chụp đã được cập nhật',
  'This study share has been deleted': 'Chia sẻ ca chụp đã bị xóa',
  'The filter has been created': 'Bộ lọc đã được tạo',
  'The filter has been updated': 'Bộ lọc đã được cập nhật',
  'The filter has been deleted': 'Bộ lọc đã bị xóa',
  'The rule CAD has been created': 'Quy tắc cho CAD đã được tạo',
  'The rule CAD has been updated': 'Quy tắc cho CAD đã được cập nhật',
  'The rule CAD has been deleted': 'Quy tắc cho CAD đã bị xóa',
  'This request has been assigned': 'Yêu cầu này đã được chỉ định',
  'This request has been updated': 'Yêu cầu này đã được cập nhật',
  'This request has been deleted': 'Yêu cầu này đã bị xóa',
  'Key image has been created': 'Key image đã được tạo',
  'This data has been deleted': 'Dữ liệu này đã bị xóa',
  'The patient account has been created':
    'Tài khoản của người bệnh đã được tạo',
  'The print job has been created': 'Lệnh in đã được tạo',
};
